import { Roles } from '@/config/roles';

/** Who runs the fleet: echo's FLEET_STAFF (fleetRoles.ts); the super admin passes every check anyway */
export const FLEET_STAFF_ROLES: string[] = [Roles.ADMIN, Roles.DISPATCHER, Roles.SUPERADMIN];

/** Drivers: My loads only */
export const DRIVER_ROLES: string[] = [Roles.DRIVER];
